import api from './api';
import { OptionProps } from '@digital/ui';

export const getAllTipoDistribuicaoForcast = () => api.get<any[]>('tipoDistribuicaoForcast');

export const getAllTipoDistribuicaoForcastOptions = () => {
    return getAllTipoDistribuicaoForcast().then(Tipo =>
        (Tipo || []).map(t => ({ text: t.nome, value: t.id.toString() } as OptionProps)),
    );
}

